import { gsap } from "gsap";  // Importing GSAP for animations
import AF from '../utlis/AF';
import { isMobile } from '../utlis/is-mobile';

const CLASS_ACTIVE = 'is-active';
const CLASS_INACTIVE = 'is-inactive';
const CLASS_FLOATING = 'is-floating';

export default class InfoPoint {
    active = false;
    activeMouse = false;
    x = null;
    y = null;
    xA = 0;
    yA = 0;

    constructor(el) {
        this.el = el;
        this.area = this.el.querySelector('[info-point-area]');
        this.floating = this.el.querySelector('[info-point-floating]');
        this.circle = this.el.querySelector('[info-point-circle]');
        this.dot = this.el.querySelector('[info-point-dot]');
        this.h = this.el.querySelector('[info-point-h]');
        this.text = this.el.querySelector('[info-point-text]');
        this.pathWrap = this.el.querySelector('[info-point-path-wrap]');
        this.path = this.pathWrap.querySelector('path');
        this.onEnter = this.onEnter.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.write = this.write.bind(this);
        this.af = AF.instance();
        this.tl = gsap.timeline({ paused: true });
        this.constructAnimation();
    }

    constructAnimation() {
      gsap.set(this.circle, { transformOrigin: "50% 50%" });

      this.tl.clear();
      this.tl
          .addLabel("begin")
          .fromTo(
              this.circle,
              0.3,
              {
                  scale: 1,
                  x: "-50%", // Center horizontally
                  y: "-50%", // Center vertically
                  width: 42,
                  height: 42,
                  borderWidth: 4,
              },
              {
                  scale: 0.5,
                  x: "-50%", // Remain centered
                  y: "-50%",
                  width: 42,
                  height: 42,
                  borderWidth: 21,
                  ease: gsap.parseEase("power2.out"), // Corrected ease
              }
          )
          .to(
              this.circle,
              0.1,
              {
                  scale: 1,
                  x: "0%",
                  y: "0%",
                  width: 150,
                  height: 150,
                  borderWidth: 75,
                  ease: gsap.parseEase("power2.out"),
              }
          )
          .to(
              this.circle,
              0.6,
              {
                  scale: 1,
                  x: "0%",
                  y: "0%",
                  width: 200,
                  height: 200,
                  borderWidth: 10,
                  ease: gsap.parseEase("power2.out"),
              }
          )
          .fromTo(
              this.dot,
              0.1,
              { scale: 1 },
              { scale: 0.2, ease: gsap.parseEase("power2.out") }
          )
          .set(this.dot, { opacity: 0 }, 0.2)
          .to(this.pathWrap, 1, { y: 0, ease: gsap.parseEase("power2.out") }, 0.35)
          .fromTo(
              this.path,
              2,
              { strokeDashoffset: 321 },
              { strokeDashoffset: 0, ease: gsap.parseEase("power2.out") },
              0.35
          )
          .to(this.h, 0.8, { x: 0, opacity: 1, ease: gsap.parseEase("power2.out") }, 0.71)
          .to(this.text, 0.8, { x: 0, opacity: 1, ease: gsap.parseEase("power2.out") }, 0.71)
          .add(() => {
              // Optional: Additional functionality or delays
          }, "+=2")
          .addLabel("revealed")
          .set(this.text, { clearProps: "all" }, "revealed+=0.1")
          .set(this.h, { clearProps: "all" }, "revealed+=0.1")
          .set(this.path, { clearProps: "all" }, "revealed+=0.1")
          .set(this.pathWrap, { clearProps: "all" }, "revealed+=0.1")
          .set(this.dot, { clearProps: "all" }, "revealed+=0.1")
          .to(
              this.circle,
              0.4,
              {
                  scale: 0.5,
                  x: "-50%",
                  y: "-50%",
                  width: 42,
                  height: 42,
                  borderWidth: 21,
                  ease: gsap.parseEase("power2.out"),
              },
              "revealed+=0.1"
          )
          .to(
              this.circle,
              0.6,
              {
                  scale: 1,
                  x: "-50%",
                  y: "-50%",
                  width: 42,
                  height: 42,
                  borderWidth: 4,
                  ease: gsap.parseEase("power2.out"),
              }
          )
          .addLabel("end")
          .progress(0);
  }
  

    activate() {
        if (this.active) return;
        this.tl.tweenFromTo("begin", "revealed");
        this.active = true;

        this.af.onNextWrite(() => {
            this.el.classList.add(CLASS_ACTIVE);
        });

        if (!isMobile) {
            this.deactivateMouse();
        }
    }

    deactivate() {
        if (!this.active) return;
        this.tl.tweenFromTo("revealed", "end");
        this.active = false;
        this.el.classList.remove(CLASS_ACTIVE);
    }

    onEnter(e) {
        this.activateMouse();
    }

    onMove(e) {
        if (!this.activeMouse) return;
        let rect = this.area.getBoundingClientRect();
        this.x = e.clientX - rect.left - rect.width / 2;
        this.y = e.clientY - rect.top - rect.height / 2;
    }

    onLeave(e) {
        this.deactivateMouse();
    }

    activateMouse() {
        this.activeMouse = true;
        this.af.addWrite(this.write);
        this.af.onNextWrite(() => {
            this.floating.classList.add(CLASS_FLOATING);
        });
    }

    deactivateMouse() {
        this.activeMouse = false;
        this.af.removeWrite(this.write);
        this.af.onNextWrite(() => {
            this.floating.classList.remove(CLASS_FLOATING);
            this.floating.style.transform = '';
            this.xA = 0;
            this.yA = 0;
        });
    }

    write() {
        if (!this.activeMouse) return;
        if (this.active) return;
        if (Math.abs(this.x - this.xA) < 0.2 && Math.abs(this.y - this.yA) < 0.2) return;

        this.xA += (this.x - this.xA) * 0.1;
        this.yA += (this.y - this.yA) * 0.1;

        this.floating.style.transform = `translate3d(${this.xA}px, ${this.yA}px, 0)`;
    }
}
